module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-mazda.45dd61df.png";